// src/components/FarmDetails/farmData.js

import divineEuphoriaImage from '../../assets/images/divine-euphoria.jpg';
import greenMeadowsImage from '../../assets/images/green-meadows.jpg';
import ganeshImage from '../../assets/images/ganesh.jpeg';
import nature from '../../assets/images/Maheshs farm.jpeg'; 
import nature1 from '../../assets/images/Nageshwars farm.jpeg'; 
import farm from '../../assets/images/Mahesh farm.jpeg'; 
export const farmData = {
  1: {
    name: 'Divine Euphoria',
    location: 'KrishnayyanaDoddi, Karnataka',
    image: divineEuphoriaImage,
    amenities: [
      { name: 'Wi-Fi', icon: 'fa-wifi' },
      { name: 'Nature Trails', icon: 'fa-tree' },
      { name: 'Organic Food', icon: 'fa-leaf' },
      { name: 'Yoga Space', icon: 'fa-yoga' }
    ],
    facilities: [
      { name: 'Private Rooms', icon: 'fa-bed' },
      { name: 'Conference Hall', icon: 'fa-chalkboard-teacher' },
      { name: 'Lounge Area', icon: 'fa-couch' },
      { name: 'Bonfire', icon: 'fa-fire' }
    ],
    images: [divineEuphoriaImage, greenMeadowsImage],
    directions: 'Located 60 km from Bangalore. Follow NH48 to Kanakapura.',
    lat: 12.9531,
    lng: 77.5785,
    description: [
      "Divine Euphoria offers a perfect getaway to escape the hustle of the city, nestled in the serene landscapes of Karnataka.",
      "The farm is dedicated to organic farming and sustainability, offering guests the chance to enjoy fresh organic food and explore nature trails."
    ],
    availableDates: ['2024-12-28', '2024-12-29', '2024-12-30'],
    bookedDates: ['2024-12-29'],
  },
  2: {
    name: 'Satish Farm',
    location: 'Wayanad, Kerala',
    image: [greenMeadowsImage,ganeshImage],
    amenities: [
      { name: 'Swimming Pool', icon: 'fa-swimmer' },
      { name: 'Bonfire', icon: 'fa-fire' },
      { name: 'Farm Tours', icon: 'fa-tractor' },
      { name: 'Luxury Cottages', icon: 'fa-bed' }
    ],
    facilities: [
      { name: 'Private Rooms', icon: 'fa-bed' },
      { name: 'Conference Hall', icon: 'fa-chalkboard-teacher' },
      { name: 'Lounge Area', icon: 'fa-couch' }
    ],
    images: [greenMeadowsImage,ganeshImage],
    directions: 'Located 80 km from Calicut Airport. Take SH29 to Wayanad.',
    lat: 11.6862,
    lng: 76.0909,
    description: [
      "Rustic Retreat is a charming farm stay located in the picturesque Wayanad region of Kerala. Surrounded by lush forests and hills.",
      "Guests can enjoy the luxury cottages with modern amenities, unwind by the swimming pool, or gather around a bonfire in the evening."
    ],
    availableDates: ['2024-12-25', '2024-12-26', '2024-12-27'],
    bookedDates: ['2024-12-26'],
  },
  3: {
    name: 'Mahesh Farm',
    location: 'Wayanad, Kerala',
    image: nature,
    amenities: [
      { name: 'Swimming Pool', icon: 'fa-swimmer' },
      { name: 'Bonfire', icon: 'fa-fire' },
      { name: 'Farm Tours', icon: 'fa-tractor' },
      { name: 'Luxury Cottages', icon: 'fa-bed' }
    ],
    facilities: [
      { name: 'Private Rooms', icon: 'fa-bed' },
      { name: 'Conference Hall', icon: 'fa-chalkboard-teacher' },
      { name: 'Lounge Area', icon: 'fa-couch' }
    ],
    images: [nature],
    directions: 'Located 80 km from Calicut Airport. Take SH29 to Wayanad.',
    lat: 11.6862,
    lng: 76.0909,
    description: [
      "Rustic Retreat is a charming farm stay located in the picturesque Wayanad region of Kerala. Surrounded by lush forests and hills.",
      "Guests can enjoy the luxury cottages with modern amenities, unwind by the swimming pool, or gather around a bonfire in the evening."
    ],
    availableDates: ['2024-12-25', '2024-12-26', '2024-12-27'],
    bookedDates: ['2024-12-26'],
  },
  4: {
    name: 'Nageshwar Farm',
    location: 'Wayanad, Kerala',
    image: [nature1],
    amenities: [
      { name: 'Swimming Pool', icon: 'fa-swimmer' },
      { name: 'Bonfire', icon: 'fa-fire' },
      { name: 'Farm Tours', icon: 'fa-tractor' },
      { name: 'Luxury Cottages', icon: 'fa-bed' }
    ],
    facilities: [
      { name: 'Private Rooms', icon: 'fa-bed' },
      { name: 'Conference Hall', icon: 'fa-chalkboard-teacher' },
      { name: 'Lounge Area', icon: 'fa-couch' }
    ],
    images: [nature1],
    directions: 'Located 80 km from Calicut Airport. Take SH29 to Wayanad.',
    lat: 11.6862,
    lng: 76.0909,
    description: [
      "Rustic Retreat is a charming farm stay located in the picturesque Wayanad region of Kerala. Surrounded by lush forests and hills.",
      "Guests can enjoy the luxury cottages with modern amenities, unwind by the swimming pool, or gather around a bonfire in the evening."
    ],
    availableDates: ['2024-12-25', '2024-12-26', '2024-12-27'],
    bookedDates: ['2024-12-26'],
  },
  5: {
    name: 'Mahesh Farm',
    location: 'Wayanad, Kerala',
    image: farm,
    amenities: [
      { name: 'Swimming Pool', icon: 'fa-swimmer' },
      { name: 'Bonfire', icon: 'fa-fire' },
      { name: 'Farm Tours', icon: 'fa-tractor' },
      { name: 'Luxury Cottages', icon: 'fa-bed' }
    ],
    facilities: [
      { name: 'Private Rooms', icon: 'fa-bed' },
      { name: 'Conference Hall', icon: 'fa-chalkboard-teacher' },
      { name: 'Lounge Area', icon: 'fa-couch' }
    ],
    images: [farm],
    directions: 'Located 80 km from Calicut Airport. Take SH29 to Wayanad.',
    lat: 11.6862,
    lng: 76.0909,
    description: [
      "Rustic Retreat is a charming farm stay located in the picturesque Wayanad region of Kerala. Surrounded by lush forests and hills.",
      "Guests can enjoy the luxury cottages with modern amenities, unwind by the swimming pool, or gather around a bonfire in the evening."
    ],
    availableDates: ['2024-12-25', '2024-12-26', '2024-12-27'],
    bookedDates: ['2024-12-26'],
  },
};
